<template>
	<div class="page-content">
		<div class="container-fluid">
				<!-- start page title -->
				<div class="row">
					<div class="col-12">
						<div class="page-title-box d-sm-flex align-items-center justify-content-between">
							<h4 class="mb-sm-0">Kamus Usulan Data</h4>

							<div class="page-title-right">
								<ol class="breadcrumb m-0">
									<li class="breadcrumb-item">
										<Link href="/admin/kamususulandata">Kamus Usulan Data</Link>
									</li>
									<li v-if="parent && parent.uraikamususulan" class="breadcrumb-item active">
										<Link :href="'/admin/kamususulandata/' + (parent.parent[0] ?? '')">{{ parent.kodekamususulan + ' ' + parent.uraikamususulan }}</Link>
									</li>
								</ol>
							</div>
						</div>
					</div>
				</div>
				<!-- end page title -->

				<div class="row">
					<div class="col-lg-12">
						<div class="card">
							<div class="card-body">
								<div class="d-flex justify-content-between">
									<div>
										<h4 class="card-title">Manajemen Kamus Usulan Data</h4>
									</div>
									<div>
										<button type="button" @click="form.show = true" class="btn btn-success">Tambah Baru</button>
									</div>
								</div>

								<hr>

								<div class="table-reponsive">
									<table class="table mb-0">
										<thead>
											<tr>
												<th class="text-center">#</th>
												<th>Kamus Usulan</th>
												<th>Perubahan Terakhir</th>
												<th class="text-center">Aksi</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(row, index) in kamususulandata" :key="index">
												<td scope="row" class="text-center">{{ index + 1 }}</td>
												<td scope="row">
													<Link v-if="row.parent.length < 2" :href="'/admin/kamususulandata/' + row.id">{{ row.kodekamususulan + ' - ' + row.uraikamususulan }}</Link>
													<span v-if="row.parent.length == 2">{{ row.kodekamususulan + ' - ' + row.uraikamususulan }}</span>
												</td>
												<td scope="row">{{ (new Date(row.updated_at)).toLocaleString() }}</td>
												<td scope="row" class="text-center">
													<a @click="edit(row)" class="p-0 btn btn-sm btn-link">Edit</a> | 
													<a @click="remove(row)" class="p-0 btn btn-sm btn-link">Hapus</a>
												</td>
											</tr>
											<tr v-if="kamususulandata.length == 0">
												<td scope="row" colspan="5" class="text-center">
													<i>Tidak ditemukan data!</i>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
		</div>
	</div>

	<modal :show="form.show" @close="form.show = false" :title="(form.id ? 'Ubah': 'Tambah') + ' Kamus Usulan'" backdrop="static">
    <template #default>
      <form @submit.prevent="action">
        <div class="mb-3">
          <label for="kodekamususulan" class="form-label">Kode Kamus Usulan</label>
          <input v-model="form.kodekamususulan" type="text" class="form-control" id="kodekamususulan" />
        </div>
        <div class="mb-3">
          <label for="uraikamususulan" class="form-label">Urai Kamus Usulan</label>
          <textarea v-model="form.uraikamususulan" id="uraikamususulan" rows="4" class="form-control"></textarea>
        </div>
      </form>
    </template>
    <template #footer>
      <button type="button" class="btn btn-primary" @click="action">Simpan</button>
    </template>
  </modal>
</template>
<script>
import Layout from '@/layout/Index'
import Modal from '@/components/Modal'

export default {
	layout: Layout,
	components: { Modal },
	props: {
		kamususulandata: Array,
		parent: Object
	},
	data() {
		return {
			form: {
				show: false,
				id: null,
				kodekamususulan: '',
				uraikamususulan: '',
				parent_id: null
			}
		}
	},
	methods: {
		edit({ id, kodekamususulan, uraikamususulan, parent_id }) {
			console.log(this.parent.parent[this.parent.parent.length - 1]);
			this.form.id = id 
			this.form.kodekamususulan = kodekamususulan
			this.form.uraikamususulan = uraikamususulan
			this.form.parent_id = parent_id
			this.form.show = true
		},
		action() {
			this.form.parent_id = (this.parent && this.parent.id) ? this.parent.id : null
			if (this.form.id) {
				this.$inertia.put('/admin/kamususulandata/' + this.form.id, this.form)
			} else {
				this.$inertia.post('/admin/kamususulandata', this.form)
			}
			this.form.show = false 
			this.form.id = null 
			this.form.kodekamususulan = ''
			this.form.uraikamususulan = ''
			this.form.parent_id = null
		},
		remove({ id }) {
			this.$inertia.delete('/admin/kamususulandata/' + id + '/' + ((this.parent && this.parent.id) ? this.parent.id : ''))
		}
	}
}
</script>